import React from 'react'
import api from 'core/api/contentstack'
import references from 'core/api/references'
import Listing from 'core/components/Listing'
import { layoutData } from 'core/layout'
import { toListingItem } from 'core/helpers/listing'
import Product from 'core/components/Product'
import { ProductCard } from 'core/components/Card'

const Products = (props: any) =>
  <Listing {...props} detail={Product} card={ProductCard} useInfiniteScroll={true} />

export default Products

export async function getStaticProps(context: any) {

  const filterId = context.params?.slug && context.params?.slug[0]
  const productId = context.params?.slug && context.params?.slug[1]

  if (productId) {
    let item: any, layout: any
    try {
      ;[item, layout] = await Promise.all([
        api.getEntryByToken('product', productId, context.locale, references.PRODUCT_DETAIL),
        layoutData(api, context.locale),
      ])
    } catch (err) {
      console.error('getStaticProps (offers/product): fetch failed', err)
      return { notFound: true, revalidate: 60 }
    }

    // revalidate: 60 — retry aggressively while CMS entry is missing or unavailable
    if (!item) return { notFound: true, revalidate: 60 }

    return {
      props: { layout: true, ...layout, item },
      revalidate: 43200,
    }
  }

  let items: any, result: any, layout: any
  try {
    ;[items, result, layout] = await Promise.all([
      api.getEntriesByContentTypeFilter("product", context.locale, filterId, ["filters", "color"]),
      api.getEntryByUrl("listing", `/offers`, context.locale, references.PRODUCT_LISTING),
      layoutData(api, context.locale),
    ])
  } catch (err) {
    console.error('getStaticProps (offers/listing): fetch failed', err)
    return { notFound: true, revalidate: 60 }
  }

  // revalidate: 60 — retry aggressively while CMS entry is missing or unavailable
  if (!result) return { notFound: true, revalidate: 60 }

  return {
    props: { layout: true, ...layout, items: (items ?? []).map(toListingItem).filter(Boolean), result, prefix: "products" },
    revalidate: 43200,
  }
}
